import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const BLIK: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Blik,
    name: 'blik',
    displayName: 'BLIK'
};
